// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-menu__column[data-v-1a201499]{display:grid;grid-row-gap:16px;row-gap:16px;margin-bottom:16px}.footer-menu__column[data-v-1a201499]:last-child{margin-bottom:0}.footer-menu__column-item-link[data-v-1a201499]{color:#626c77;text-decoration:none;font-size:17px;line-height:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
